import * as firebase from 'firebase';
import { ENV_DEV, ENV_LOCAL } from '../constants/env';

const prodConfig = {
  apiKey: 'AIzaSyB7GCbNwqgoxIhsJq3cFiGvqr5kiIDTtdk',
  authDomain: 'kobooprod.firebaseapp.com',
  databaseURL: 'https://kobooprod.firebaseio.com',
  projectId: 'kobooprod',
  storageBucket: 'kobooprod.appspot.com',
  messagingSenderId: '390620808375',
};

const devConfig = {
  apiKey: 'AIzaSyCN30M31h2loJn3Vib56VcfrkHpomq3fnA',
  authDomain: 'koboodev-49df5.firebaseapp.com',
  databaseURL: 'https://koboodev-49df5.firebaseio.com',
  projectId: 'koboodev-49df5',
  storageBucket: 'koboodev-49df5.appspot.com',
  messagingSenderId: '642780026927',
};

// REACT_APP_ENV Must be defined in order to use devConfig else it will automatically select prodConfig EVEN if it is not in prod
const config = (process.env.REACT_APP_ENV === ENV_DEV || process.env.REACT_APP_ENV === ENV_LOCAL)
  ? devConfig
  : prodConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();

export {
  auth,
  db,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js